import React, { memo } from 'react';
import { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from 'react-router-dom';
import Select from "react-select";
import swal from "sweetalert";
import LoandSideBar from "../../LoansSideBar"
import LoansUploadModal from "../../LoansModel"
import { toast } from "react-toastify";
import loanCss from '../../../../css/loanRegisterIrac.module.css'

import Breadcrumb from "../../../../components/Breadcrumb"
import commoncss from "../../../../css/common.module.css"

import { getAllLoanIRACScenario, selectLoanIRACScenario, loansListing, updateIRAC, uploadIRAC, getIRACLoanList, IRACOverride, calculateIRAC, addToLoanListing, getLoansData } from '../../../../../Bookclosure/Services/ApiHandler'

import  { ReactComponent as PervBtnIcon }  from '../../../../assets/icons/pervECLBtnIcon.svg'
import  { ReactComponent as BreadCrumbsdor }  from '../../../../assets/icons/breadCrumbsDot.svg'
import  { ReactComponent as EditIcon }  from '../../../../assets/icons/editCard.svg'
import  { ReactComponent as CompleteECLIcon }  from '../../../../assets/icons/completeECL.svg'
import  { ReactComponent as RefershIcon }  from '../../../../assets/icons/loanRegisterRefersh.svg'
import  { ReactComponent as LoaderIcon }  from '../../../../assets/icons/loansLoader.svg'
import  { ReactComponent as LoandiracLeftCard }  from '../../../../assets/icons/loansIracLeftCard.svg'
import  { ReactComponent as LoandiracRightCard }  from '../../../../assets/icons/loansIracRightCard.svg'
import  { ReactComponent as RemoveLoanIcon }  from '../../../../assets/icons/removeLoansIcons.svg'
import  { ReactComponent as IracCorrectIcon }  from '../../../../assets/icons/iracCorrectIcon.svg'
import  { ReactComponent as CustModeLCloseIcon }  from '../../../../assets/icons/custModeLCloseIcon.svg'
import  { ReactComponent as LoansUploadIcon }  from '../../../../assets/icons/loansUploadIcon.svg'
import  { ReactComponent as LoansAddIcon }  from '../../../../assets/icons/loansAdd.svg'
import  { ReactComponent as RepeatIcon }  from '../../../../assets/icons/repeatIcon.svg'
import  { ReactComponent as NextBtnIcon }  from '../../../../assets/icons/rightWhite.svg'

import Table from "../../../../elements/Table"


const ReceivablesRegisterIrac = () => {

    const { id, companyId } = useParams();
    const [loanID, setloanID] = useState(id)
    const [companyID, setcompanyID] = useState(companyId)
    // const [companyID, setcompanyID] = useState('6655b5365ce609ea146c5c53')

    // Stage One
    const [stageOneOptions , setStageOneOptions] = useState([])
    const [stageOneScenarioId , setstageOneScenarioId] = useState()
    
    // Stage Two
    const fileInputRef = useRef(null);
    const handleManualUpload = () => {
        fileInputRef.current.click();
    };

    const [loansListThData,setloansListThData] = useState()
    const [loansListTbData,setloansListTbData] = useState()
    
    const [loansUploadModal,setLoanUploadModal] = useState(false)
    const [loanListingSelectModel,setloanListingSelectModel] = useState(false)
    const [loanSelectModel,setloanSelectModel] = useState(false)

    
    const [selectedLoans, setSelectedLoans] = useState([]);
    const [selectedAllCheckBox, setselectedAllCheckBox] = useState(false)
    const [selectedNormalCheckBoxs, setselectedNormalCheckBoxs] = useState([])
    
    const [iracOverRideSelect, setiracOverRideSelect] = useState([])
    const [iracOverRideSelectVal, setiracOverRideSelectVal] = useState([])

    
    const [iracUpdatedLoanListing, setiracUpdatedLoanListing] = useState([]) // list of select loans from loans listing
    const [overRideSelectedAllCheckBox, setoverRideSelectedAllCheckBox] = useState(false)
    const [overRideSelectedNormalCheckBoxs, setoverRideSelectedNormalCheckBoxs] = useState({})
    
    const [overRideSelectedLoans, setoverRideSelectedLoans] = useState([]); // {}

    const [overRideOverView, setoverRideOverView] = useState([])

    const stageTwoReason = useRef('');

    const handleReasonUpdate = (val) => {
        stageTwoReason.current = val;
    };

    const overRideHandleRowSelect = (loanID, customerID, checked, index, stage) => {
        
        if (checked) {
            setoverRideSelectedLoans(prev => [...prev, { loanID, customerID: String(customerID) , beforeOverride: stage}]);
        } 
        else {
            setoverRideSelectedLoans(prev => prev.filter(item => item.loanID !== loanID));
            setoverRideSelectedAllCheckBox(false)
        }

        // update based on the loan key
        setoverRideSelectedNormalCheckBoxs(prev => ({
            ...prev,
            [loanID]: checked
        }));

    };

    const rmLoan = (rmLoanid) => {
        const updatedList = iracUpdatedLoanListing.filter(item => item.loanID !== rmLoanid);
        setiracUpdatedLoanListing(updatedList);
    };

    const overRideHandleSelectAll = (checked) => {
        if (checked) {
            setoverRideSelectedAllCheckBox(true);
            // setoverRideSelectedNormalCheckBoxs(new Array(iracUpdatedLoanListing.length).fill(true));
            const selectAllCheckBoxState = iracUpdatedLoanListing.reduce((acc, row) => {
                acc[row.loanID] = true;
                return acc;
                }, {});

            setoverRideSelectedNormalCheckBoxs(selectAllCheckBoxState);
            
            const all = iracUpdatedLoanListing.map(row => ({
                loanID: row["loanID"],
                customerID: String(row["customerID"]),
                beforeOverride: row['beforeOverride']
            }));
            setoverRideSelectedLoans(all);
        }
        else {
            // When user unchecks the box
            setoverRideSelectedAllCheckBox(false);
            // setoverRideSelectedNormalCheckBoxs(new Array(iracUpdatedLoanListing.length).fill(false));
            const initialCheckBoxState = iracUpdatedLoanListing.reduce((acc, row) => {
                acc[row.loanID] = false;
                return acc;
                }, {});

            setoverRideSelectedNormalCheckBoxs(initialCheckBoxState);

            setoverRideSelectedLoans([]);
        }
    };

    const handleRowSelect = (loanID, customerID, checked, index) => {
        if (checked) {
            // setSelectedLoans(prev => [...prev, { loanID, customerID }]);
            setSelectedLoans(prev => [...prev, { loanID, customerID: String(customerID) }]);

        } else {
            // remove if it was un checked
            setSelectedLoans(prev => prev.filter(item => item.loanID !== loanID));
            setselectedAllCheckBox(false)

        }

        // update checkbox at index
        setselectedNormalCheckBoxs(prev => {
            const updated = [...prev];
            updated[index] = checked;
            return updated;
        });
    };

    const handleSelectAll = (checked) => {
        if (checked) {
            // When user checks the box
            setselectedAllCheckBox(true);
            setselectedNormalCheckBoxs(new Array(loansListTbData.length).fill(true));

            const all = loansListTbData.map(row => ({
                loanID: row["loanID"],
                customerID: String(row["customerID"])
            }));

            setSelectedLoans(all);
        }
        else {
            // When user unchecks the box
            setselectedAllCheckBox(false);
            setselectedNormalCheckBoxs(new Array(loansListTbData.length).fill(false));
            setSelectedLoans([]);
        }
    };

    const updateIracLoan = () => {
        let data = {
                'IRACLoanList':selectedLoans
        }
        updateIRAC(loanID,data).then(res => {
            getIRACLoanList(loanID).then(res => {
                setiracUpdatedLoanListing(res.data.IRACLoanList)
                
                let iracOptList = res.data.IRACProvisionList
                const options = iracOptList.map(item => ({
                    value: item,
                    label: item
                }));

                setiracOverRideSelect(options)
                setiracOverRideSelectVal(options[0].value)
            })
        })
    }

    const overRide = () => {

        const updatedLoans = overRideSelectedLoans.map(({ customerID, ...rest }) => ({
            ...rest,
            afterOverride: iracOverRideSelectVal,
            reason: stageTwoReason.current
        }));

        let obj = {
            'IRACOverrideList' : updatedLoans
        }

        IRACOverride(loanID, obj).then(res => {
            if (res.data.success === true) {
                toast.success(res.data.message);
            } else {
                toast.error(res.data.error || 'Something went wrong');
                swal("Override Failed", res.data.error || "Something went wrong!", "error");
            }
        });

        const finalOverrideArray = updatedLoans.map((overrideItem, index) => {
        const matchedItem = iracUpdatedLoanListing.find(listItem => listItem.loanID === overrideItem.loanID);
            return {
                sno: matchedItem ? matchedItem.sno || index + 1 : `#${index + 1}`,
                loanID: overrideItem.loanID,
                customerID: matchedItem ? matchedItem.customerID || "Customer Id" : "Customer Id",
                beforeOverride: matchedItem ? matchedItem.beforeOverride || "?" : "?",
                afterOverride: overrideItem.afterOverride || "Not Set",
                reason: overrideItem.reason || "No Reason Provided"
            };
        });
        
        setoverRideOverView(finalOverrideArray)
    }

    // calling api's when page loaded
    useEffect(() => {
        
        // Stage One
        getAllLoanIRACScenario(companyID).then(res => {
            let iracLst = res.data.loanIRACScenarioList

            // Map loan list to dropdown format
            const formattedOptions = iracLst.map(iracLst => ({
                value: iracLst._id,
                label: iracLst.name
            }));

            setStageOneOptions(formattedOptions);
            // setstageOneScenarioId(formattedOptions?.[0]?.value)
        })

        // Stage Two Loan listing
        loansListing(loanID).then((res) => {
            const headers = res.data.loanListingHeaders.map((h) => ({
                header: h,
                accessor: h,
            }));
            setloansListThData(headers);
            setloansListTbData(res.data.loanListing);
        });


        getLoansData(loanID).then( res => {
            // console.log('stageOneScenarioId :: ',stageOneScenarioId);
                let secanrioId = res.data.loan.loanIRACScenarioID
                let loanLst = res.data.loan.IRACLoanList

                setstageOneScenarioId(secanrioId)
                setoverRideOverView(loanLst)
            }
        )
    }
    ,[])

    // useEffect(() => {
    //     console.log('stageOneScenarioId :: -- ',stageOneScenarioId);    
    // },[stageOneScenarioId])

    
    // active stage
    const [ActiveStage, setActiveStage] = useState(1)

    const selectedStage = (currentActivatedStage) => {
        setActiveStage(currentActivatedStage)
    }

    const numberofStages = [1, 2, 3]

    // =============================================
    // Start Stage two states 
        const [stepInStageTwo, setstepInStageTwo] = useState(1)
        const [file, setFile] = useState(null);
        const [dragActive, setDragActive] = useState(false);
        // const [selectStage, setselectStage] = useState();
        // const [ReasonForOveride, setReasonForOveride] = useState("");

        const [stageThreeTh, setstageThreeTh] = useState([])
        const [stageThreeTb, setstageThreeTb] = useState([])

       
    // End Stage two states 

    // stage three
    const [StageThreePostition, setStageThreePostition] = useState(1)
    const changeStateAfterDelay = () => {
        
        setStageThreePostition(2)

        calculateIRAC(loanID).then(res => {
            setstageThreeTh(res.data.IRACHeaders)
            setstageThreeTb(res.data.IRACTable)
            setStageThreePostition(3); // change this to whatever value you want
        })
    };

    const addLoanToListing = () => {
        addToLoanListing(loanID,'IRAC').then(() => {
            toast.success("Successfully Add to Loan listing.");
        })
    }

    // start over 
    const startOver = (from) => {
        if(from === 'stageTwo'){
            setstepInStageTwo(1)
        }
    }

    const editOverRide = () => {
        setstepInStageTwo(2)
    }

    const handleModels = (model) => {
        
        setloanSelectModel(false)

        if(model === 'loanListing'){
            setloanListingSelectModel(true)
        }

        if(model === 'uploadLoansFile'){
            setLoanUploadModal(true)
        }
    }

    

    return (
        <div style={{ display: 'flex' }}>
            <LoandSideBar 
                id = {id}
                companyId={companyId}
                activeTab={'Compute Calculations'}
                subMenuItem={'IRAC'} 
            />

            {loanListingSelectModel &&(
                <CustmLoanSelectModel 
                    setloanListingSelectModel={setloanListingSelectModel}
                    handleRowSelect={handleRowSelect}
                    handleSelectAll={handleSelectAll}
                    loansListThData={loansListThData}
                    loansListTbData={loansListTbData}
                    selectedLoans={selectedLoans}
                    setstepInStageTwo={setstepInStageTwo}
                    selectedAllCheckBox={selectedAllCheckBox}
                    setselectedAllCheckBox={setselectedAllCheckBox}
                    selectedNormalCheckBoxs={selectedNormalCheckBoxs}
                    updateIracLoan={updateIracLoan}
                />
            )}

            {loansUploadModal &&(
                <LoansUploadModel 
                    fileInputRef={fileInputRef}
                    handleManualUpload={handleManualUpload}
                    setLoanUploadModal={setLoanUploadModal}
                    setstepInStageTwo={setstepInStageTwo}
                    loanID={loanID}
                    setiracOverRideSelect={setiracOverRideSelect}
                    setiracOverRideSelectVal={setiracOverRideSelectVal}
                    setiracUpdatedLoanListing={setiracUpdatedLoanListing}
                />
            )}

            {loanSelectModel &&(
                <StepOneInStageTwo 
                    setloanListingSelectModel={setloanListingSelectModel}
                    setloanSelectModel={setloanSelectModel}
                    setLoanUploadModal={setLoanUploadModal}
                    handleModels={handleModels}
                />
            )}

            <div className={loanCss.mainContainer}>

                <EclHeader 
                    ActiveStage={ActiveStage}
                    setActiveStage={setActiveStage}
                    companyID={companyID}
                    loanID={loanID}
                />
                
                {numberofStages.includes(ActiveStage) ? (
                        <StageNumberBadge 
                            ActiveStage={ActiveStage}
                            setActiveStage={setActiveStage}
                        />
                ) : ''}
                    
                <div className={ numberofStages.includes(ActiveStage) ? loanCss.subContainer : loanCss.subCatgeoryContainer}>

                        {
                            ActiveStage === 1 ?
                            
                                <div className={
                                    numberofStages.includes(ActiveStage)
                                    ? loanCss.stagesContantHoldContainer
                                    : loanCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                }>
                                    <StageOne 
                                        stageOneOptions={stageOneOptions}
                                        stageOneScenarioId={stageOneScenarioId}
                                        setstageOneScenarioId={setstageOneScenarioId}
                                    />
                                </div>

                            :
                            
                            ActiveStage === 2 ? 
                                
                                <div className={
                                        numberofStages.includes(ActiveStage)
                                        ? loanCss.stagesContantHoldContainerTwo
                                        : loanCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                }>
                                    <StageTwo 
                                        fileInputRef ={fileInputRef}
                                        handleManualUpload = {handleManualUpload}
                                        handleReasonForOverRideValue={handleReasonUpdate} 
                                        // reason={reason}
                                        // setreason={setreason}
                                        // handleReasonForOverRideValue={handleReasonForOverRideValue}
                                        setloanSelectModel={setloanSelectModel}  
                                        editOverRide={editOverRide}
                                        startOver={startOver}
                                        stepsInStageTwo={stepInStageTwo}
                                        setstepInStageTwo={setstepInStageTwo}
                                        file={file}
                                        setFile={setFile}
                                        dragActive={dragActive} 
                                        setDragActive={setDragActive}
                                        // optionsStageTwo={optionsStageTwo}
                                        // selectStage={selectStage}
                                        // setselectStage={setselectStage}
                                        // ReasonForOveride={ReasonForOveride}
                                        // setReasonForOveride={setReasonForOveride}
                                        ActiveStage={ActiveStage}
                                        loansListThData={loansListThData}
                                        loansListTbData={loansListTbData}
                                        handleRowSelect={handleRowSelect}
                                        handleSelectAll={handleSelectAll}
                                        selectedLoans={selectedLoans}
                                        setLoanUploadModal={setLoanUploadModal}
                                        setloanListingSelectModel={setloanListingSelectModel}
                                        iracUpdatedLoanListing={iracUpdatedLoanListing}
                                        overRideHandleRowSelect={overRideHandleRowSelect}

                                        overRideSelectedLoans={overRideSelectedLoans}
                                        overRideSelectedAllCheckBox={overRideSelectedAllCheckBox}
                                        overRideSelectedNormalCheckBoxs={overRideSelectedNormalCheckBoxs}
                                        overRideHandleSelectAll={overRideHandleSelectAll}
                                        iracOverRideSelect={iracOverRideSelect}
                                        setiracOverRideSelectVal={setiracOverRideSelectVal}
                                        iracOverRideSelectVal={iracOverRideSelectVal}
                                        overRide={overRide}
                                        rmLoan={rmLoan}
                                        overRideOverView={overRideOverView}
                                    />
                                </div>
                            :

                            ActiveStage === 3 ? 
                                <StageThree
                                    changeStateAfterDelay={changeStateAfterDelay}
                                    StageThreePostition={StageThreePostition} 
                                    setStageThreePostition={setStageThreePostition}
                                    stageThreeTh={stageThreeTh}
                                    stageThreeTb={stageThreeTb}
                                    addLoanToListing={addLoanToListing}
                                /> 
                            :
                            
                            null
                        }

                    {/* </div> */}

                </div>

                {numberofStages.includes(ActiveStage) ? (
                        <EclFooter 
                            ActiveStage={ActiveStage}
                            setActiveStage={setActiveStage}

                            loanID={loanID}
                            stageOneScenarioId={stageOneScenarioId}

                            stepsInStageTwo={stepInStageTwo}
                            setstepInStageTwo={setstepInStageTwo}
                            overRideOverView={overRideOverView}
                        />
                ) : ''}
           
            </div>


        </div>
    );
};

export default ReceivablesRegisterIrac;


const StageNumberBadge = ({
    ActiveStage,
    setActiveStage,
    }) => {

        var outerBadge1 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`
        var innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
        var badgeConnecter1 = `${loanCss.numbConnterStart2} ${loanCss.inactiveBadgeBgClr}`
        var content1 = 1

        var outerBadge2 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`
        var innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
        var badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.inactiveBadgeBgClr}`
        var content2 = 2

        var outerBadge3 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`
        var innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
        var badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.inactiveBadgeBgClr}`
        var content3 = 3

        if (ActiveStage === 1) {
                outerBadge1 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`;
                innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
                badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.activeBadgeBgClr}`
                content1 = 1
            } 
            else if (ActiveStage === 2) {
                outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
                innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
                badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.completedBadgConnecterClr}`
                content1 = <CompleteECLIcon />

                outerBadge2 =  `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`
                innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
                badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.middleActiveBar} `

                badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.lastInActiverBar} `
            } 
            else if (ActiveStage === 3) {
                outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
                innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
                badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr} `
                content1 = <CompleteECLIcon />

                outerBadge2 =  `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`
                innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
                badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr} `
                content2 = <CompleteECLIcon />

                outerBadge3 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`
                innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
                badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.lastConnecter} `
            } 

    return (
        <div className={loanCss.numBadgeMainContainer}>
            <div className={loanCss.numberContainer}>
                <div onClick={ () => {} } key={1} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerOne}`}>
                    <div className={badgeConnecter1}></div>
                    <div className={`${outerBadge1} ${loanCss.badge}`} >
                        <div className={innerBadge1}>{content1}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText1}`}>Scenario</div>
                </div>
                <div onClick={ () => {} } key={2} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerTwo}`}>
                    <div className={badgeConnecter2}></div>
                    <div className={`${outerBadge2} ${loanCss.badge}`}>
                        <div className={innerBadge2}>{content2}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText2}`}>qualitative override</div>
                </div>
                <div onClick={ () => {} } key={3} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerThree}`}>
                    <div className={badgeConnecter3}></div>
                    <div className={`${outerBadge3} ${loanCss.badge}`}>
                        <div className={innerBadge3}>{content3}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText3}`}>compute irac</div>
                </div>
            </div>
        </div>
    );
};



// const StageNumberBadge = ({
//     ActiveStage,
//     setActiveStage,
//     }) => {

//         var outerBadge1 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter1 = `${loanCss.numbConnterStart2} ${loanCss.inactiveBadgeBgClr}`
//         var content1 = 1

//         var outerBadge2 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.inactiveBadgeBgClr}`
//         var content2 = 2

//         var outerBadge3 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.inactiveBadgeBgClr}`
//         var content3 = 3

//         if (ActiveStage === 1) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.activeBadegClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.activeBadgeBgClr}`
//                 content1 = 1
//             } 
//             else if (ActiveStage === 2) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.completedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${loanCss.numBadge} ${loanCss.activeBadegClr}`
//                 innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.activeBadgeBgClr}`
//             } 
//             else if (ActiveStage === 3) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.completedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${loanCss.numBadge} ${loanCss.activeBadegClr}`
//                 innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.activeBadgeBgClr}`
//             } 

//     return (

//         <div className={loanCss.numBadgeMainContainer}>
//             <div className={loanCss.numberContainer}>
//                 <div onClick={ () => {} } key={1} className={outerBadge1}>
//                     <div className={badgeConnecter1}></div>
//                     <div className={innerBadge1}>{content1}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText1}`}>Scenario</div>
//                 </div>
//                 <div onClick={ () => {} } key={2} className={outerBadge2}>
//                     <div className={badgeConnecter2}></div>
//                     <div className={innerBadge2}>{content2}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText2}`}>qualitative override</div>
//                 </div>
//                 <div onClick={ () => {} } key={3} className={outerBadge3}>
//                     <div className={badgeConnecter3}></div>
//                     <div className={innerBadge3}>{content3}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText3}`}>compute irac</div>
//                 </div>
//             </div>
//         </div>
//     );
// };


const StageOne = ({
    stageOneOptions,
    stageOneScenarioId,
    setstageOneScenarioId,
    }) => {
        console.log('stageOneScenarioId comp : ',stageOneScenarioId);
    return(
        <div className={loanCss.stage1MainContainer}>
            <div className={loanCss.stage1SubContainer}>
                
                <div>
                    <div className={loanCss.scenarioLabelClr}>Scenario</div>
                    <div className={loanCss.editPolicyContainer}>
                        <Select
                            components={{ IndicatorSeparator: () => null }} // remove separator
                            value={stageOneScenarioId ? stageOneOptions.find(option => option.value === stageOneScenarioId) : stageOneOptions?.[0]}
                            onChange={(selectedOption) => setstageOneScenarioId(selectedOption.value)}
                            options={stageOneOptions}
                            placeholder="Select Scenario"
                            name="status"
                            className={`mt-0 ${loanCss.scenarioSelect}`}
                            classNamePrefix="select"
                            styles={customStyles}
                            isClearable={false}
                            isSearchable={false}
                        />
                        <div className={loanCss.stageOneEditScenarioContainer}>
                            <span>
                                <EditIcon className={loanCss.scenarioEditIcon} />
                            </span>
                            <span className={loanCss.customGreenText}>
                                Edit in Policies
                            </span>
                        </div>
                    </div>
                </div>
               
                
            </div>
        </div>
    )
    
}


const CustmLoanSelectModel = ({
    setloanListingSelectModel,
    handleRowSelect,
    handleSelectAll,
    loansListThData,
    loansListTbData,
    selectedLoans,
    setstepInStageTwo,
    selectedAllCheckBox,
    setselectedAllCheckBox,
    selectedNormalCheckBoxs,
    updateIracLoan
}) => {
    return(
        <div className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`} onClick={() => {}} >
            <div className={loanCss.loanSelectCustTableWrapperContainer}>
                <div className={loanCss.loanSelectmodelHeadingCont}>
                    <div className={loanCss.loanSelectmodelHeading}>Select Loans</div>
                    <div> 
                        <CustModeLCloseIcon className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`} 
                            onClick={() => {setloanListingSelectModel(false);}}
                        /> 
                    </div>
                </div>
                <div className={`${loanCss.loansSelectMainContainer} ${loanCss.customscroll}`}>
                        {/* <div className={loanCss.tableContainer}> */}
                        <table className={loanCss.customTable}>
                        <thead>
                            <tr className={loanCss.stickyTh}>
                                <th>
                                    <input 
                                        type="checkbox" 
                                        name="" id="" 
                                        checked={selectedAllCheckBox === true}
                                        onChange={(e) => handleSelectAll(e.target.checked)}
                                    />
                                </th>
                                {loansListThData?.map((col, i) => (
                                    <th key={i}>{col.header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {loansListTbData?.length > 0 ? (
                                loansListTbData?.map((row, i) => (
                                    <tr key={i}>
                                        <td>
                                            <input type="checkbox" name="" id="" 
                                                key={i}
                                                // checked={selectedLoans.some(item => item.loanID === row["Loan ID"])}
                                                checked={selectedNormalCheckBoxs?.[i] === true}
                                                onChange={(e) =>
                                                    handleRowSelect(row["loanID"], row["customerID"], e.target.checked, i)
                                                }
                                            />
                                        </td>
                                        {loansListThData?.map((col, j) => (
                                            <td key={j}>{row[col.accessor]}</td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                            <tr>
                                <td colSpan={loansListThData?.length} style={{ textAlign: "center" }}>
                                No data found
                                </td>
                            </tr>
                            )}
                        </tbody>
                        </table>
                    {/* </div> */}

                </div>
                <div className={loanCss.loanSelectModelBtnContainer}>
                    <button type="button" className={loanCss.custModelFooterBtnSecondary}
                        onClick={() => {setloanListingSelectModel(false);}}
                    >Cancel</button>
                    <div>
                        <button type="button" className={loanCss.custModellonaSelectModelBtn}> {selectedLoans?.length === 0 ? "" : `(${(selectedLoans?.length)})` } SELECTED</button>
                        <button type="button" 
                            style={{ marginLeft:'15px' }} 
                            className={loanCss.custModelFooterBtnPrimary}
                            onClick={() => {setloanListingSelectModel(false); setstepInStageTwo(2); updateIracLoan();}}
                        >Proceed</button>
                    </div>
                </div>
            </div>
        </div>
    )
} 


const LoansUploadModel = ({
    setLoanUploadModal,
    setstepInStageTwo,
    fileInputRef,
    handleManualUpload,
    loanID,
    setiracOverRideSelect,
    setiracOverRideSelectVal,
    setiracUpdatedLoanListing,
}) => {
    const [dragActive, setDragActive] = useState(false);
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false); // New state for tracking upload status
    const [uploadError, setUploadError] = useState(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleRemoveFile = () => {
        setFile(null);
        // Crucial fix: Clear the input's value to allow re-uploading the same file
        if (fileInputRef.current) {
            fileInputRef.current.value = null; // or ''
        }
    };

    const uploadFileToApi = async () => {
        if (!file) {
            setUploadError("Please select a file to upload.");
            return;
        }

        if (!loanID) {
            setUploadError("Loan ID is missing. Cannot upload file.");
            return;
        }

        setUploading(true);
        setUploadError(null);

        const formData = new FormData();
        formData.append('file', file); // Key 'file' matches your Postman setup and backend expectation

        try {
            // Call your API function
            const result = await uploadIRAC(loanID, formData); // Pass loanID and formData
            console.log('Upload successful:', result);

            getIRACLoanList(loanID).then(res => {
                setiracUpdatedLoanListing(res.data.IRACLoanList)
                
                let iracOptList = res.data.IRACProvisionList
                const options = iracOptList.map(item => ({
                    value: item,
                    label: item
                }));

                setiracOverRideSelect(options)
                setiracOverRideSelectVal(options[0].value)
            })

            setLoanUploadModal(false);
            setstepInStageTwo(2);

        } catch (error) {
            // Error handling from the API call
            console.error('Error uploading file:', error);
            // Check if error.response exists for more specific API error messages
            const errorMessage = error.response && error.response.data && error.response.data.message
                                 ? error.response.data.message
                                 : error.message || 'An unexpected error occurred during upload.';
            setUploadError(errorMessage);
        } finally {
            setUploading(false);
        }
    };

  return (
    <div
      className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`}
      onClick={() => {
        setLoanUploadModal(false);
      }}
    >
      <div
        className={loanCss.cutmModelMainContainer}
        onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
      >
        <div className={loanCss.custModelHeader}>
          <div className={loanCss.custModelHeaderLabel}>Upload Loans</div>
          <div>
            <CustModeLCloseIcon
              className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`}
              onClick={() => setLoanUploadModal(false)}
            />
          </div>
        </div>

        <div className={loanCss.cutModelBodyContainer}>
          <div
            className={`${loanCss.dragDropArea} ${dragActive ? loanCss.dragActive : ''}`}
            onDragEnter={handleDrag}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
          >
            <label htmlFor="file-upload" className={loanCss.dragDropLabel}>
              Drag and drop your file here or
              <button type="button" 
                onClick={handleManualUpload}
                className={loanCss.custModelUploadBtn}>
                    <LoansUploadIcon className={loanCss.loanUploadIcon} />
                    &nbsp; 
                    Upload
              </button>
            </label>
            <input
                id="file-upload"
                type="file"
                onChange={handleFileChange}
                className={loanCss.hiddenFileInput}
                ref={fileInputRef}
            />
          </div>

          <div className={loanCss.loanUploadInfo}>
            File you upload must contain all the mandatory fields for mapping.
            {/* Display upload error message */}
            {uploadError && (
                <p style={{ color: 'red', marginTop: '10px' }}>{uploadError}</p>
            )}

          </div>

          {file && (
            <p className={`${loanCss.selectedFile} ${loanCss.fileUploadedIcon}`}>
              File Name  {file.name} 
              <span className={loanCss.fileRmIcon}
                onClick={() => {
                    // setFile(null)
                    handleRemoveFile();
                }}
            > 
                <RemoveLoanIcon /> 
            </span>
            </p>
          )}
        </div>

        <div className={loanCss.cutModelFooterContainer}>
          <button
            type="button"
            onClick={() => setLoanUploadModal(false)}
            className={loanCss.custModelFooterBtnSecondary}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={uploadFileToApi}
            className={loanCss.custModelFooterBtnPrimary}
            disabled={uploading || !file || !loanID} // Disable if no file or no loanID
        >
            {uploading ? 'Uploading...' : 'Proceed'}
        </button>
        </div>
      </div>
    </div>
  );
};

const StageTwo = ({
    
    setloanSelectModel,
    editOverRide,
    startOver,
    stepsInStageTwo,
    setstepInStageTwo,
    file,
    setFile,
    dragActive,
    setDragActive,
    // ReasonForOveride, 
    // setReasonForOveride,
    loansUploadModal,
    setLoanUploadModal,
    setloanListingSelectModel,
    iracUpdatedLoanListing,
    overRideSelectedAllCheckBox,
    overRideSelectedNormalCheckBoxs,
    overRideHandleRowSelect,
    overRideHandleSelectAll,
    iracOverRideSelect,
    setiracOverRideSelectVal,
    iracOverRideSelectVal,
    overRide,
    rmLoan,
    overRideOverView,
    handleReasonForOverRideValue,
    // reason,
    // setreason
}) => {

    const reasonRef = useRef('');


    const StepOneInStageTwo = ({
        setLoanUploadModal,
        setloanListingSelectModel
    }) => {
        return(
            <div className={loanCss.stageTwoCardsMainContainer}>
                <div className={loanCss.stageTwoheadingText}>
                    Select loans to perform qualitative override
                </div>
                <div className={loanCss.stageTwocardsContainer}>
                    <div>
                        <LoandiracLeftCard className={loanCss.stagetwocards} onClick={() => {setloanListingSelectModel(true)} }/>
                    </div>
                    <div>
                        <LoandiracRightCard className={loanCss.stagetwocards} onClick={() => {setLoanUploadModal(true)}}/>
                    </div>
                </div>
            </div>
        )
    }

    const StepTwoInStageTwo = () => {
        return(
            <div className={loanCss.stepTwoStageTwo}>
                <div className={loanCss.stageTwoLeftContainer}>
                    <div className={loanCss.stageTwoLabel}>Selected or Uploaded Loans</div>
                    <div className={loanCss.custTable}>
                        <div className={loanCss.custTableHeader}>
                            <div className={loanCss.custTableHeaderItem1}>
                                <input className={loanCss.stageTwoStepInpt} 
                                    type="checkbox" name="" id="" 
                                    checked={overRideSelectedAllCheckBox === true}
                                    onChange={(e) => overRideHandleSelectAll(e.target.checked)}    
                                />
                            </div>
                            <div className={loanCss.custTableHeaderItem2}>
                                Loan Id
                            </div>
                            <div className={loanCss.custTableHeaderItem3}>
                                Customer Id
                            </div>
                            <div className={loanCss.custTableHeaderItem4}>
                                Stage
                            </div>
                        </div>
                        <div className={`${loanCss.custTableBody} ${loanCss.customscroll}`}>
                            {iracUpdatedLoanListing?.map((loan, i) => (
                                <React.Fragment key={i}>
                                <div className={loanCss.custTableBodyItem1}>
                                    <input
                                        type="checkbox"
                                        className={loanCss.stageTwoStepInpt}
                                        checked={overRideSelectedNormalCheckBoxs?.[loan.loanID] === true}
                                        onChange={(e) => overRideHandleRowSelect(loan["loanID"], loan["customerID"], e.target.checked, i, loan['beforeOverride'] )
                                        }
                                    />
                                </div>
                                <div className={loanCss.custTableBodyItem2}>{loan.loanID}</div>
                                <div className={loanCss.custTableBodyItem3}>{loan.customerID}</div>
                                <div className={loanCss.custTableBodyItem4}>
                                    <div>{loan.beforeOverride}</div>
                                    <div className={`${loanCss.rmIconContainer} ${loanCss.custmCursor}`} onClick={() => {rmLoan(loan["loanID"])}}>
                                        <RemoveLoanIcon />
                                    </div>
                                </div>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                    <button 
                        type="button" 
                        className={loanCss.noBorderBtn}
                        onClick={() => {setloanSelectModel(true)}}
                    ><span style={{ marginBottom:'5px' }}><LoansAddIcon /></span> &nbsp; Add more loans</button>
                </div>
                <div className={loanCss.stageTwoRightContainer}>
                    <div className={loanCss.stageTwoRightSubContainer}>
                        <div className={`${loanCss.stageTwoAlrtBox} ${loanCss.mb20}`}> 
                            <span> <IracCorrectIcon /> </span> {iracUpdatedLoanListing?.length} loans moved to stage 1 successfully
                        </div>
                        <div className={loanCss.mb20}>
                            <div className={loanCss.stageCommontLabel}>Override Selected Loans to</div>
                            <Select
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                defaultValue={iracOverRideSelect[0]}
                                value={iracOverRideSelectVal ? iracOverRideSelect.find(option => option.value === iracOverRideSelectVal) : iracOverRideSelect?.[0]}
                                onChange={(selectedOption) => setiracOverRideSelectVal(selectedOption.value)}
                                options={iracOverRideSelect}
                                placeholder="Select stage"
                                name="status"
                                className={`mt-0 ${loanCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={`${loanCss.mb20}`}>
                            <div className={loanCss.stageCommontLabel}>Reason for override</div>
                            <div>
                                <textarea
                                    className={loanCss.stageTwoTextArea}
                                    onChange={(e) => {
                                        reasonRef.current = e.target.value;
                                    }}
                                    onBlur={() => {
                                        handleReasonForOverRideValue(reasonRef.current);
                                    }}
                                    rows={5}
                                    cols={40}
                                    placeholder="Reason..."
                                />
                            </div>
                        </div>
                        <div>
                            <button 
                                type="button" 
                                className={loanCss.custModelFooterBtnPrimary}
                                onClick={() => {overRide()}}
                            >Override</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const StepThreeInStageTwo = () => {
        return(
            <div className={loanCss.stepthreeStageThreeContainer}>
                <div className={loanCss.stepthreeStageThreeHeader}>
                    Override Summary
                </div>
                <div className={loanCss.stepTwoStageTwocustTable}>
                    <div className={loanCss.custTableHeader}>
                        <div className={loanCss.custTableHeaderItem1}>
                            Loan Id
                        </div>
                        <div className={loanCss.custTableHeaderItem2StageTwo}>
                            Customer Id
                        </div>
                        <div className={loanCss.custTableHeaderItem3StageTwo}>
                            before override
                        </div>
                        <div className={loanCss.custTableHeaderItem4}>
                            after override
                        </div>
                    </div>
                    <div className={`${loanCss.custTableBody} ${loanCss.customscroll}`}>
                        {overRideOverView?.map((item, i) => (
                            <React.Fragment key={i}>
                                <div className={loanCss.custTableBodyItem1}>
                                    {item.sno || item.loanID}
                                </div>
                                <div className={loanCss.custTableBodyItem2StageTwo}>
                                    {item.customerID || 'Customer id'}
                                </div>
                                <div className={loanCss.custTableBodyItem3StageTwo}>
                                    {item.beforeOverride}
                                </div>
                                <div className={loanCss.custTableBodyItem4}>
                                    <div>{item.afterOverride}</div>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
                <div className={loanCss.stepthreeStageThreeFooter}>
                    <button 
                        type="button"
                        className={loanCss.noBorderBtn}
                        onClick={() => {startOver('stageTwo')}}>
                             <RepeatIcon style={{ height:'16px' }} /> &nbsp; Start Over
                    </button>
                    <button 
                        onClick={() => {editOverRide()}}
                        type="button" 
                        className={loanCss.custSecondaryBtn}
                        > <EditIcon style={{ height:'16px' }}/> Edit Override
                    </button>
                </div>
            </div>
        )
    }

    // const FileDragAndDrop = ({
    //     setLoanUploadModal
    // }) => {

    //     const handleDrag = (e) => {
    //         e.preventDefault();
    //         e.stopPropagation();
    //         if (e.type === "dragenter" || e.type === "dragover") {
    //         setDragActive(true);
    //         } else if (e.type === "dragleave") {
    //         setDragActive(false);
    //         }
    //     };

    //     const handleDrop = (e) => {
    //         e.preventDefault();
    //         e.stopPropagation();
    //         setDragActive(false);
    //         if (e.dataTransfer.files[0]) {
    //         setFile(e.dataTransfer.files[0]);
    //         }
    //     };

    //     const handleFileChange = (e) => {
    //         if (e.target.files[0]) {
    //         setFile(e.target.files[0]);
    //         }
    //     };

    //     return (
    //         <div className={loanCss.fielUploadMainContainer}>
    //         <div className="modal-box">
    //             <h2 className="modal-title">Upload Leases</h2>

    //             <div
    //                 className={`drop-zone ${dragActive ? "active" : ""}`}
    //                 onDragEnter={handleDrag}
    //                 onDragOver={handleDrag}
    //                 onDragLeave={handleDrag}
    //                 onDrop={handleDrop}
    //             >
    //             <label htmlFor="file-upload" className="upload-label">
    //                 <div className="upload-content">
    //                 <p>Drag and drop your file here or</p>
    //                 <button className="upload-btn">Upload</button>
    //                 </div>
    //             </label>
    //             <input
    //                 id="file-upload"
    //                 type="file"
    //                 onChange={handleFileChange}
    //                 className="hidden-input"
    //             />
    //             </div>

    //             <p className="description">Lorem ipsum dolor sit amet consectetur. Amet.</p>

    //             {file && <p className="selected-file">📁 Selected: {file.name}</p>}

    //             <div className="button-group">
    //             <button className="cancel-btn">Cancel</button>
    //             <button className="proceed-btn">Proceed</button>
    //             </div>
    //         </div>
    //         </div>
    //     );

    // }


    // const LoansUploadModel = ({
    //     setLoanUploadModal,
    //     setstepInStageTwo,
    // }) => {
    //     return(
    //         <div className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`} onClick={() => {setLoanUploadModal(false)}} >
    //             <div className={loanCss.cutmModelMainContainer}>
    //                 <div className={loanCss.custModelHeader}>
    //                     <div className={loanCss.custModelHeaderLabel}>
    //                         Upload Leases
    //                     </div>
    //                     <div>
    //                         <CustModeLCloseIcon className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`} />
    //                     </div>
    //                 </div>
    //                 <div className={loanCss.cutModelBodyContainer}>
    //                     <div className={loanCss.dragDropArea}>
    //                         <div className={loanCss.dragDropLabel}>Drag and drop your file here or</div>
    //                         <button type="button" className={loanCss.custModelUploadBtn}> <LoansUploadIcon className={loanCss.loanUploadIcon}/> &nbsp; Upload</button>
    //                     </div>
    //                     <div className={loanCss.loanUploadInfo}>
    //                         Lorem ipsum dolor sit amet consectetur. Amet.
    //                     </div>
    //                 </div>
    //                 <div className={loanCss.cutModelFooterContainer}>
    //                     <button type="button" 
    //                         onClick={() => {setLoanUploadModal(false)}} 
    //                         className={loanCss.custModelFooterBtnSecondary}>Cancel</button>
    //                     <button type="button" 
    //                         onClick={() => {setLoanUploadModal(false); setstepInStageTwo(2);}} 
    //                         className={loanCss.custModelFooterBtnPrimary}
    //                         >Proceed</button>
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // } 



    return(
        <React.Fragment>
            {
                stepsInStageTwo === 1 ? 
                    <React.Fragment>

                        <StepOneInStageTwo 
                            setLoanUploadModal = {setLoanUploadModal}
                            setloanListingSelectModel = {setloanListingSelectModel}
                        />

                        {/* <FileDragAndDrop /> */}

                        {/* {loansUploadModal &&(
                            <React.Fragment>
                                <LoansUploadModel 
                                    setLoanUploadModal = {setLoanUploadModal}
                                    setstepInStageTwo = {setstepInStageTwo}
                                    />
                            </React.Fragment>
                        )} */}

                    </ React.Fragment>
                :
                stepsInStageTwo === 2 ? 
                    <StepTwoInStageTwo />
                :
                stepsInStageTwo === 3 ? 
                    <StepThreeInStageTwo />
                :
                null
            }
        </React.Fragment>
    )

//   return (
//     <>
//       {stepsInStageTwo === 1 && (
//         <>
//           <StepOneInStageTwo 
//             setLoanUploadModal={setLoanUploadModal} 
//             setloanListingSelectModel={setloanListingSelectModel} 
//           />
//           {loansUploadModal && (
//             <LoansUploadModel 
//               setLoanUploadModal={setLoanUploadModal} 
//               setstepInStageTwo={setstepInStageTwo} 
//             />
//           )}
//         </>
//       )}
      
//       {stepsInStageTwo === 2 && <StepTwoInStageTwo />}
      
//       {stepsInStageTwo === 3 && <StepThreeInStageTwo />}
//     </>
//   );
// };

    
}


const StageThree = ({
    ActiveStage,
    setActiveStage,
    changeStateAfterDelay,
    StageThreePostition, 
    setStageThreePostition,
    stageThreeTh,
    stageThreeTb,
    addLoanToListing
    }) => {

    const StageSixStartCompute = () =>{
        return(
            <div className={loanCss.computeMainContainer}>
                <div className={loanCss.computeContainer}>
                    <div className={loanCss.DedupecomputText}>Lorem ipsum dolor sit amet consectetur.Scelerisque</div>
                    <div className={loanCss.DedupecomputText}>luctus morbi odio orci. Tellus risus et id.</div>
                    <div> 
                        <button type="button" 
                            style={{ marginTop:'20px' }} className={`${loanCss.stageSixBtn} ${loanCss.stageSixPrimaryBtn}`}
                            onClick={() => {changeStateAfterDelay()}}
                        >Compute IRAC</button> </div>
                </div>
            </div>
        )
    }

    const StageSixLoader = () => {
        return(
            <div className={loanCss.computeMainContainer}>
                <div className={loanCss.computeContainerLoader}>
                    <LoaderIcon className={loanCss.spininfinite} />
                    <div className={loanCss.computText}>Computation in progress</div>
                    <div className={loanCss.computText}>This might take a few minutes, Please wait...</div>
                </div>
            </div>
        )
    }

    const StageSixDataView = () => {
        return(
            <div className={loanCss.stageSixMainContainer}>
            <div className={loanCss.stageSixbtnContainer}>
                <div className={loanCss.stageSixbtnLeftContainer}> 
                    <button style={{ marginRight : '10px' }} type="button" className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixSecondaryBtn}`}> <RefershIcon /> Refresh</button> 
                    <button className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixSecondaryBtn}`} type="button">Start Over</button> 
                </div>
                <div className={loanCss.stageSixbtnRightContainer}> 
                    <button 
                        style={{ marginLeft : '10px' }} 
                        type="button" 
                        className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixPrimaryBtn}`}
                        onClick={() => addLoanToListing()}
                        >Add columns to loan listing</button> 
                </div>
            </div>

            <div className={loanCss.stageThreeScrollWrapper}>
                <div className={loanCss.stageThreeTable}>
                    <div className={loanCss.stageThreeTableHeader}>
                        {stageThreeTh?.map((header, index) => (
                            <div key={index} className={loanCss.stageThreeTableHeaderItem}>
                                {header}
                            </div>
                        ))}
                    </div>
                    <div className={loanCss.stageSixTableBody}>
                        {stageThreeTb?.map((row, rowIndex) => (
                            <React.Fragment key={rowIndex}>
                                <div className={loanCss.stageThreeTableBodyRow}>
                                {stageThreeTh.map((header, cellIndex) => (
                                    <div key={`${rowIndex}-${cellIndex}`} className={loanCss.stageThreeTableBodyItem}>
                                    {row[header] ?? "-"}
                                    </div>
                                ))}
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </div>
        )
    }
    

    return(
        <React.Fragment>
            {StageThreePostition === 1 && <StageSixStartCompute />}
            {StageThreePostition === 2 && <StageSixLoader />}
            {StageThreePostition === 3 && <StageSixDataView />}
        </React.Fragment>
    )
    
}


const EclHeader = ({
    ActiveStage,
    setActiveStage,
    companyID,
    loanID,
    }) => {
    const breadcrumbItems = [
        {
            label: "Loan Register",
            link: `/myfinV2/overview/${loanID}/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Compute Calculations",
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "IRAC",
            className: `${commoncss.nav_cnt_color} clickable`,
        },
    ];
    return(
        // <div className={loanCss.headerContainer}>
        //     <div className={loanCss.eclbreadCumbs} 
        //         onClick={() => {
        //             if (ActiveStage === 'view') {
        //                 setActiveStage(6);
        //             }
        //         }}
        //         >
        //         <PervBtnIcon />
        //     </div>
        //     <div className={loanCss.headerBreadCrumbsText}>
        //         Loans
        //     </div>
        //     <div className={loanCss.breadCumbContainer}>
        //         <BreadCrumbsdor />
        //     </div>
        //     <div className={loanCss.headerBreadCrumbsText}>
        //         IRAC
        //     </div>
        // </div>
        <Breadcrumb
            addCls="bgTransprent"
            items={breadcrumbItems}
            headerActions={<></>}
            p0={true}
        />
    )
}


const EclFooter = ({ 
    
    ActiveStage,
    setActiveStage,

    loanID,
    stageOneScenarioId,

    stepsInStageTwo,
    setstepInStageTwo,
    overRideOverView

    }) => {

    const routerHistory = useHistory();
    const handleClick = (Link) => {
        routerHistory.push(Link);
    };

    return(
        <div className={loanCss.footerContainer}>
            <div>
                <button 
                onClick={() => {}}
                className={loanCss.cancelBtn} type="button">Cancel</button>
            </div>
            <div className={loanCss.footerbtnContainer}>
                <button onClick={() => {
                            if (ActiveStage !== 1) {
                                setActiveStage(ActiveStage - 1);
                            }
                        }}
                        className={loanCss.perviewBtn} type="button"> <PervBtnIcon />  Previous</button>
                <button onClick={()=>{ 
                            if(ActiveStage === 1){
                                if(overRideOverView?.length > 0){
                                    setstepInStageTwo(3)
                                }
                            }
                            if(ActiveStage === 2){
                                if(stepsInStageTwo === 3){
                                    setActiveStage(3)
                                    return
                                }
                                setstepInStageTwo(3)
                                return
                            }
                            if(ActiveStage !== 3){
                                if(ActiveStage === 1){
                                    selectLoanIRACScenario(loanID,stageOneScenarioId)
                                }
                                setActiveStage(ActiveStage + 1) 
                            }
                            else{
                            }
                }} 
                className={loanCss.saveBtn} type="button">
                    { ActiveStage === 3 ? 'Finish' : 'Next'}<NextBtnIcon/>
                </button>
            </div>
        </div>
    )
}



// const StepOneInStageTwo = ({
//         setLoanUploadModal,
//         setloanListingSelectModel
//     }) => {
//         return(
//             <div className={loanCss.stageTwoCardsMainContainer}>
//                 <div className={loanCss.stageTwoheadingText}>
//                     Select loans to perform qualitative override
//                 </div>
//                 <div className={loanCss.stageTwocardsContainer}>
//                     <div>
//                         <LoandiracLeftCard className={loanCss.stagetwocards} onClick={() => {setloanListingSelectModel(true)} }/>
//                     </div>
//                     <div>
//                         <LoandiracRightCard className={loanCss.stagetwocards} onClick={() => {setLoanUploadModal(true)}}/>
//                     </div>
//                 </div>
//             </div>
//         )
//     }


const StepOneInStageTwo = ({
    setloanListingSelectModel,
    setLoanUploadModal,
    handleModels,
    setloanSelectModel
}) => {
    return(
        <div className={`${loanCss.cutModelForDragLaonsIrac} custmfadein`} onClick={() => {}} >
            
                <div className={loanCss.stageTwocardsContainer}>
                        <div className={loanCss.popWrapperContainer}>
                            <div className={loanCss.headerContainerFrPop}>
                                <div>Add Loans</div>
                                <div>
                                    <CustModeLCloseIcon className={`${loanCss.custModelHeaderCloseicon} ${loanCss.cursiorPointer}`} 
                                        onClick={() => {setloanSelectModel(false)}}
                                    />
                                </div>
                            </div>
                            <div className={loanCss.boxsWrapperContainer}>
                                <div>
                                    <LoandiracLeftCard className={loanCss.stagetwocards} onClick={() => {handleModels('loanListing')} }/>
                                </div>
                                <div>
                                    <LoandiracRightCard className={loanCss.stagetwocards} onClick={() => {handleModels('uploadLoansFile')}}/>
                                </div>
                            </div>
                    </div>
                </div>
        </div>
    )
} 


export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//       ? '#f4faf5'
//       : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     borderRadius: '8px',
//     // margin: '4px 6px',
//   }),
option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent',
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};
